// DO NOT USE THIS COMPONENT without checking in with the growth monetization core team
// https://private.hubteam.com/janus/groups/hs-monetization-core-fe

import { useCallback, useEffect, useState } from 'react';
import enviro from 'enviro';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Text } from 'foundations-components/components/Text';
import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { track } from './_core/common/eventTracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RequestAccessModalWrapper = ({
  buttonBlock,
  buttonDisabled,
  buttonSize,
  buttonUse,
  buttonSeleniumId,
  buttonTestId,
  OpenModalButtonLabel,
  floatingAlertStore,
  ModalBody,
  ModalTitle,
  modalUse = 'default',
  modalWidth = 480,
  onClickOpenModal = () => {},
  onAccessRequest,
  SubmitRequestButtonLabel,
  usageTrackingProperties
}) => {
  const [showModal, setShowModal] = useState(false);
  const displayAndTrackViewOfRequestAccessModal = useCallback(() => {
    setShowModal(true);
    onClickOpenModal();
    track('viewUpgradeAdminPrompt', usageTrackingProperties);
  }, [onClickOpenModal, usageTrackingProperties]);
  const handleSendRequest = useCallback(() => {
    onAccessRequest().then(() => {
      setShowModal(false);
      floatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestAccessModalWrapper.onSuccessAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestAccessModalWrapper.onSuccessAlert.title"
        }),
        type: 'success'
      });
    }).catch(__error => {
      floatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestAccessModalWrapper.onFailureAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestAccessModalWrapper.onFailureAlert.title"
        }),
        type: 'danger'
      });
    });
  }, [floatingAlertStore, onAccessRequest]);
  const monCoreTeamUrl = `${getFullUrl('private', {
    domainOverride: 'hubteam'
  })}/janus/groups/hs-monetization-core-fe`;
  useEffect(() => {
    // show warning only in QA, excluding ui-addon-upgrades-playground
    if (!window.location.href.includes('growth-playground') && enviro.isQa()) {
      console.warn(`RequestAccessModalWrapper: DO NOT USE THIS COMPONENT without checking in with the growth monetization core team (${monCoreTeamUrl})`);
    }
  }, [monCoreTeamUrl]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      block: buttonBlock,
      "data-selenium-id": buttonSeleniumId,
      "data-test-id": buttonTestId,
      onClick: displayAndTrackViewOfRequestAccessModal,
      size: buttonSize,
      use: buttonUse,
      disabled: buttonDisabled,
      children: OpenModalButtonLabel
    }), showModal && /*#__PURE__*/_jsxs(Modal, {
      use: modalUse,
      width: modalWidth,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          "data-test-id": "admin-modal-close-button",
          onClick: () => {
            setShowModal(false);
          }
        }), /*#__PURE__*/_jsx(H2, {
          children: ModalTitle
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(Text, {
          paddingInlineEnd: "400",
          children: ModalBody
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "admin-modal-submit-button",
          use: buttonUse,
          onClick: handleSendRequest,
          children: SubmitRequestButtonLabel
        })
      })]
    })]
  });
};